// Catalog item kinds (mirrors the Rails PartnerCatalogItem enum). Shared between
// the carousel card and the stories viewer.
export const KIND_LABEL = {
  produto: 'Produto',
  case: 'Case',
  institucional: 'Institucional',
  anuncio: 'Anúncio',
  servico: 'Serviço',
  lancamento: 'Lançamento',
  midia: 'Vídeo / Banner'
}

const VIDEO_FILE_RE = /\.(mp4|webm|mov|m4v)(\?|#|$)/i
const YOUTUBE_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/i
const VIMEO_RE = /vimeo\.com\/(?:video\/)?(\d+)/i

/**
 * Resolves the playable video source of a catalog item. The catalog builder
 * stores videos in the free `link` field (YouTube/Vimeo/direct file) — `media`
 * is an image upload (poster), never the video. Returns null when the item has
 * no embeddable video.
 *
 * @returns {{ type: 'youtube'|'vimeo'|'file', url: string }|null}
 */
export const getVideoSource = item => {
  const link = item?.link || ''
  const mediaUrl = item?.media?.file?.url || ''
  const mediaName = item?.media?.name || ''

  const yt = link.match(YOUTUBE_RE)
  if (yt) {
    const id = yt[1]
    return {
      type: 'youtube',
      url: `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&modestbranding=1&rel=0&playsinline=1`
    }
  }

  const vm = link.match(VIMEO_RE)
  if (vm) {
    return {
      type: 'vimeo',
      url: `https://player.vimeo.com/video/${vm[1]}?autoplay=1&muted=1&loop=1&background=1`
    }
  }

  if (VIDEO_FILE_RE.test(link)) return { type: 'file', url: link }
  if (VIDEO_FILE_RE.test(mediaUrl) || VIDEO_FILE_RE.test(mediaName)) {
    return { type: 'file', url: mediaUrl }
  }

  return null
}

export const isVideoItem = item => getVideoSource(item) !== null

// Shared crop for catalog media (bug: partner-catalog-card-content-cut). The
// story-strip thumbnail (PartnerCatalog) is a fixed 136×196 box; the
// full-screen viewer (PartnerStoriesViewer) reuses this exact ratio so an
// image previews the same framing it will show when expanded — before this,
// the viewer cropped to a separate fixed height, re-cropping the image
// differently than what the producer saw while uploading.
export const CATALOG_MEDIA_ASPECT_CLASS = 'aspect-[136/196]'
